export default {
	title: '诊断报告',
	selectOrg: '选择组织',
	selectAll: '全选',
	selectedItems: '已选择 {count} 项',
	batchDelete: '批量删除',
	batchDeleteWithCount: '批量删除 ({count})',
	sendEmail: '发送邮件',
	sendEmailWithCount: '发送邮件 ({count})',
	noData: {
		title: '暂无诊断报告',
		description: '当前没有找到相关的诊断报告数据'
	},
	reportCard: {
		coverAlt: '诊断报告封面',
		maker: '编制人',
		updateTime: '更新时间'
	},
	actions: {
		check: '核对',
		download: '下载',
		modify: '修改',
		delete: '删除',
		sendEmail: '发送邮件',
		batchDelete: '批量删除'
	},
	configDialog: {
		title: '诊断报告核对',
		reportConfig: '报告核对',
		warnConfig: '告警核对',
		projectName: '项目名称',
		deviceName: '设备名称',
		reportTime: '报告生成时间',
		author: '编制方',
		warnItem: '告警项',
		delete: '删除',
		faultLocation: '故障部位',
		faultType: '故障类型',
		selectFaultType: '请选择故障类型',
		alarmLevel: '告警等级',
		selectAlarmLevel: '请选择告警等级',
		alarmCount: '告警次数',
		diagnosisAnalysis: '诊断分析',
		enterDiagnosisAnalysis: '请输入诊断分析',
		relatedAtlas: '相关图谱',
		addAtlas: '添加图谱',
		diagnosisConclusion: '诊断结论',
		enterDiagnosisConclusion: '请输入诊断结论',
		maintenanceSuggestion: '维护建议',
		enterMaintenanceSuggestion: '请输入维护建议',
		alarmStartTime: '告警开始时间',
		alarmEndTime: '告警结束时间',
		selectDateTime: '选择日期时间',
		regenerate: '重新生成'
	},
	emailDialog: {
		title: '发送邮件',
		ccPerson: '抄送人',
		selectCcPerson: '请选择抄送人',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		selectReportWarning: '请选择诊断报告',
		selectCcPersonWarning: '请选择抄送人',
		sendSuccess: '发送成功',
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		configSuccess: '诊断报告配置成功',
		uploadImageError: '只能上传图片文件!',
		uploadImageSizeError: '图片大小不能超过 5MB!',
		selectedCount: '已选择 {count} 项',
		operateSuccess: '操作成功'
	},
	form: {
		fileName: '报告名称',
		startTime: '开始时间',
		endTime: '结束时间',
		reportTitle: '报告标题',
		maker: '编制人',
		orgId: '所属部门',
		result: '诊断结果',
		fileViewInDoc: '文件内查看',
		diagnosticReport: '诊断报告',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		add: '新增',
		update: '修改'
	},
	table: {
		reportTitle: '报告标题',
		diagnosticReport: '诊断报告',
		maker: '编制人',
		orgId: '所属部门',
		result: '诊断结果',
		updateTime: '诊断时间'
	}
}
